import { Fragment, ReactNode } from 'react';

import { Stack } from '@components/stack';

export type JourneyCardListProps<TItem> = {
  items: TItem[];
  getKey(item: TItem): string;
  renderItem(item: TItem): ReactNode;
};

/**
 * A plain (non-virtualized) list: a windowing viewport needs a resolvable
 * pixel height and every ancestor on these surfaces is auto-height, so the
 * list renders plainly and the 500-item endpoint cap bounds it.
 */
export const JourneyCardList = <TItem,>({
  items,
  getKey,
  renderItem,
}: JourneyCardListProps<TItem>) => {
  return (
    <Stack space={2}>
      {items.map((item) => (
        <Fragment key={getKey(item)}>{renderItem(item)}</Fragment>
      ))}
    </Stack>
  );
};
